// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Brygada 1918', 'Brygada 1918 Fallback'","fontStyle":"normal"},"className":"__className_68972f","variable":"__variable_68972f"};